import type { DynamicClient } from '@dynamic-labs-sdk/client';
import type { EvmWalletAccount } from '@dynamic-labs-sdk/evm';

import type { KernelClient } from '../../KernelClient.types';
import { shouldUseEIP7702 } from '../shouldUseEIP7702';

type ShouldSignWithEoaParams = {
  kernelClient: KernelClient;
  smartWalletAccount: EvmWalletAccount;
};

export const shouldSignWithEoa = async (
  { kernelClient, smartWalletAccount }: ShouldSignWithEoaParams,
  client: DynamicClient
) => {
  const useEIP7702 = shouldUseEIP7702({ smartWalletAccount }, client);

  if (!useEIP7702) {
    return false;
  }

  const isDeployed = await kernelClient.account.isDeployed();

  return !isDeployed;
};
